var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars, $hash2 = Opal.hash2;

  Opal.add_stubs(['$setPrefixes', '$join', '$collect', '$prefixs', '$sub', '$===', '$debug', '$to_i', '$getWaponTable', '$rollJudge', '$[]', '$getJudgeDiceList', '$inject', '$+', '$nil?', '$>=', '$length', '$getSuccessText', '$getWaponSkillText', '$max', '$roll', '$<<', '$%', '$==', '$first', '$<=', '$!=', '$getSkillText', '$empty?', '$upcase', '$getWaponTableSword', '$getWaponTableSwordCounter', '$getWaponTableLongSword', '$getWaponTableLongSwordCounter', '$getWaponTableShortSword', '$getWaponTableShortSwordCounter', '$getWaponTableSpear', '$getWaponTableSpearCounter', '$getWaponTableAx', '$getWaponTableAxCounter', '$getWaponTableClub', '$getWaponTableClubCounter', '$getWaponTableBow', '$getWaponTableMartialArt', '$getWaponTableMartialArtCounter', '$getWaponTableBoxing', '$getWaponTableBoxingCounter', '$getWaponTableProWrestling', '$getWaponTableProWrestlingCounter', '$getWaponTableStand', '$getWaponTableStandCounter', '$getRandMartialArtCounter', '$*', '$each']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'ShinkuuGakuen');

    var $nesting = [self].concat($parent_nesting), $ShinkuuGakuen_gameName$1, $ShinkuuGakuen_gameType$2, $ShinkuuGakuen_getHelpMessage$3, $ShinkuuGakuen_rollDiceCommand$4, $ShinkuuGakuen_rollJudge$6, $ShinkuuGakuen_getJudgeDiceList$8, $ShinkuuGakuen_getSuccessText$9, $ShinkuuGakuen_getSkillText$10, $ShinkuuGakuen_getWaponTable$11, $ShinkuuGakuen_getWaponTableSword$12, $ShinkuuGakuen_getWaponTableSwordCounter$13, $ShinkuuGakuen_getWaponTableLongSword$14, $ShinkuuGakuen_getWaponTableLongSwordCounter$15, $ShinkuuGakuen_getWaponTableShortSword$16, $ShinkuuGakuen_getWaponTableShortSwordCounter$17, $ShinkuuGakuen_getWaponTableSpear$18, $ShinkuuGakuen_getWaponTableSpearCounter$19, $ShinkuuGakuen_getWaponTableAx$20, $ShinkuuGakuen_getWaponTableAxCounter$21, $ShinkuuGakuen_getWaponTableClub$22, $ShinkuuGakuen_getWaponTableClubCounter$23, $ShinkuuGakuen_getWaponTableBow$24, $ShinkuuGakuen_getWaponTableMartialArt$25, $ShinkuuGakuen_getWaponTableMartialArtCounter$26, $ShinkuuGakuen_getRandMartialArtCounter$27, $ShinkuuGakuen_getWaponTableBoxing$28, $ShinkuuGakuen_getWaponTableBoxingCounter$29, $ShinkuuGakuen_getWaponTableProWrestling$30, $ShinkuuGakuen_getWaponTableProWrestlingCounter$31, $ShinkuuGakuen_getWaponTableStand$32, $ShinkuuGakuen_getWaponTableStandCounter$33, $ShinkuuGakuen_getWaponSkillText$34;

    
    self.$setPrefixes(["CRL.*", "CSW.*", "CLS.*", "CSS.*", "CSP.*", "CAX.*", "CCL.*", "CMA.*", "CBX.*", "CPR.*", "CST.*", "RL.*", "SW.*", "LS.*", "SS.*", "SP.*", "AX.*", "CL.*", "BW.*", "MA.*", "BX.*", "PR.*", "ST.*"]);
    
    Opal.def(self, '$gameName', $ShinkuuGakuen_gameName$1 = function $$gameName() {
      var self = this;

      return "真空学園"
    }, $ShinkuuGakuen_gameName$1.$$arity = 0);
    
    Opal.def(self, '$gameType', $ShinkuuGakuen_gameType$2 = function $$gameType() {
      var self = this;

      return "ShinkuuGakuen"
    }, $ShinkuuGakuen_gameType$2.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $ShinkuuGakuen_getHelpMessage$3 = function $$getHelpMessage() {
      var self = this;

      return "" + "・判定\n" + "RLx：技能ベースｘで技能チェックのダイスロール\n" + "RLx>=y：この書式なら目標値 ｙ で判定結果出力\n" + "　例）RL10　　RL22>=50\n" + "\n" + "・武器攻撃\n" + "（武器記号）（技能ベース値）\n" + "　例）SW10　BX30\n" + "武器を技能ベースでダイスロール。技発動までチェック。\n" + "武器記号は以下の通り\n" + "　SW：剣、LS：大剣、SS：小剣、SP：槍、\n" + "　AX：斧、CL：棍棒、BW：弓、MA：体術、\n" + "　BX：ボクシング、PR：プロレス、ST：幽波紋\n" + "\n" + "・カウンター攻撃\n" + "カウンター技は武器記号の頭に「C」をつけるとロール可能。\n" + "　例）CSW10　CBX76\n"
    }, $ShinkuuGakuen_getHelpMessage$3.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $ShinkuuGakuen_rollDiceCommand$4 = function $$rollDiceCommand(command) {
      var $$5, $a, self = this, prefixsRegText = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, waponCommand = nil, base = nil, diff = nil, waponInfo = nil, output_msg = nil;

      
      prefixsRegText = $send(self.$prefixs(), 'collect', [], ($$5 = function(i){var self = $$5.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$sub(/\.\*/, "");}, $$5.$$s = self, $$5.$$arity = 1, $$5)).$join("|");
      if ($truthy(new RegExp("" + "(^|\\s)(S)?(" + (prefixsRegText) + ")([\\d\\+\\-]*)(>=(\\d+))?", 'i')['$==='](command))) {
      } else {
        
        self.$debug("NOT match");
        return nil;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug("matched.");
      waponCommand = __last__match__3;
      base = __last__match__4.$to_i();
      diff = __last__match__6;
      waponInfo = self.$getWaponTable(waponCommand);
      output_msg = self.$rollJudge(base, diff, waponInfo);
      return output_msg;
    }, $ShinkuuGakuen_rollDiceCommand$4.$$arity = 1);
    
    Opal.def(self, '$rollJudge', $ShinkuuGakuen_rollJudge$6 = function $$rollJudge(base, diff, waponInfo) {
      var $$7, self = this, waponName = nil, waponTable = nil, diceList = nil, total = nil, allTotal = nil, diffText = nil, result = nil;

      
      self.$debug("rollJudge base", base);
      self.$debug("rollJudge diff", diff);
      waponName = waponInfo['$[]']("name");
      waponTable = waponInfo['$[]']("table");
      diceList = self.$getJudgeDiceList();
      total = $send(diceList, 'inject', [], ($$7 = function(value, i){var self = $$7.$$s || this;

      
        
        if (value == null) {
          value = nil;
        };
        
        if (i == null) {
          i = nil;
        };
        return (value = $rb_plus(value, i));}, $$7.$$s = self, $$7.$$arity = 2, $$7));
      allTotal = $rb_plus(total, base);
      diffText = (function() {if ($truthy(diff['$nil?']())) {
        return ""
      } else {
        return "" + ">=" + (diff)
      }; return nil; })();
      result = "" + "(" + (waponName) + "：" + (base) + (diffText) + ") ＞ 1D100+" + (base) + " ＞ " + (total);
      if ($truthy($rb_ge(diceList.$length(), 2))) {
        result = $rb_plus(result, "" + "[" + (diceList.$join(",")) + "]")};
      result = $rb_plus(result, "" + "+" + (base));
      result = $rb_plus(result, "" + " ＞ " + (allTotal));
      result = $rb_plus(result, self.$getSuccessText(allTotal, diff, diceList, waponTable));
      result = $rb_plus(result, self.$getWaponSkillText(waponTable, diceList.$max()));
      self.$debug("check_1D100 result", result);
      return result;
    }, $ShinkuuGakuen_rollJudge$6.$$arity = 3);
    
    Opal.def(self, '$getJudgeDiceList', $ShinkuuGakuen_getJudgeDiceList$8 = function $$getJudgeDiceList() {
      var $a, $b, $c, self = this, diceList = nil, value = nil, rank01 = nil;

      
      diceList = [];
      while ($truthy(true)) {
        
        $c = self.$roll(1, 100), $b = Opal.to_ary($c), (value = ($b[0] == null ? nil : $b[0])), $c;
        diceList['$<<'](value);
        rank01 = value['$%'](10);
        self.$debug("rank01", rank01);
        if ($truthy(rank01['$=='](0))) {
        } else {
          break;
        };
      };
      return diceList;
    }, $ShinkuuGakuen_getJudgeDiceList$8.$$arity = 0);
    
    Opal.def(self, '$getSuccessText', $ShinkuuGakuen_getSuccessText$9 = function $$getSuccessText(allTotal, diff, diceList, isWapon) {
      var $a, self = this, first = nil, result = nil, skillText = nil, success = nil;

      
      first = diceList.$first();
      if ($truthy(first['$nil?']())) {
        return ""};
      if ($truthy($rb_le(first, 9))) {
        return " ＞ ファンブル"};
      if ($truthy(($truthy($a = diff['$nil?']()) ? first['$!='](10) : $a))) {
        return ""};
      result = "";
      skillText = self.$getSkillText(first, diff, isWapon);
      result = $rb_plus(result, skillText);
      if ($truthy(diff['$nil?']())) {
      } else {
        
        if ($truthy(skillText['$empty?']())) {
          result = $rb_plus(result, " ＞ ")};
        success = (function() {if ($truthy($rb_ge(allTotal, diff.$to_i()))) {
          return "成功"
        } else {
          return "失敗"
        }; return nil; })();
        result = $rb_plus(result, "" + (success));
      };
      return result;
    }, $ShinkuuGakuen_getSuccessText$9.$$arity = 4);
    
    Opal.def(self, '$getSkillText', $ShinkuuGakuen_getSkillText$10 = function $$getSkillText(first, diff, isWapon) {
      var self = this, result = nil;

      
      result = "";
      if ($truthy(isWapon)) {
        return result};
      result = " ＞ ";
      if ($truthy(first['$=='](10))) {
      } else {
        return result
      };
      result = $rb_plus(result, "技能なし：ファンブル");
      if ($truthy(diff['$nil?']())) {
        return result};
      result = $rb_plus(result, "／技能あり：");
      return result;
    }, $ShinkuuGakuen_getSkillText$10.$$arity = 3);
    
    Opal.def(self, '$getWaponTable', $ShinkuuGakuen_getWaponTable$11 = function $$getWaponTable(waponCommand) {
      var self = this, $case = nil;

      
      self.$debug("getWaponTable waponCommand", waponCommand);
      $case = waponCommand.$upcase();
      if ("SW"['$===']($case)) {return self.$getWaponTableSword()}
      else if ("CSW"['$===']($case)) {return self.$getWaponTableSwordCounter()}
      else if ("LS"['$===']($case)) {return self.$getWaponTableLongSword()}
      else if ("CLS"['$===']($case)) {return self.$getWaponTableLongSwordCounter()}
      else if ("SS"['$===']($case)) {return self.$getWaponTableShortSword()}
      else if ("CSS"['$===']($case)) {return self.$getWaponTableShortSwordCounter()}
      else if ("SP"['$===']($case)) {return self.$getWaponTableSpear()}
      else if ("CSP"['$===']($case)) {return self.$getWaponTableSpearCounter()}
      else if ("AX"['$===']($case)) {return self.$getWaponTableAx()}
      else if ("CAX"['$===']($case)) {return self.$getWaponTableAxCounter()}
      else if ("CL"['$===']($case)) {return self.$getWaponTableClub()}
      else if ("CCL"['$===']($case)) {return self.$getWaponTableClubCounter()}
      else if ("BW"['$===']($case)) {return self.$getWaponTableBow()}
      else if ("MA"['$===']($case)) {return self.$getWaponTableMartialArt()}
      else if ("CMA"['$===']($case)) {return self.$getWaponTableMartialArtCounter()}
      else if ("BX"['$===']($case)) {return self.$getWaponTableBoxing()}
      else if ("CBX"['$===']($case)) {return self.$getWaponTableBoxingCounter()}
      else if ("PR"['$===']($case)) {return self.$getWaponTableProWrestling()}
      else if ("CPR"['$===']($case)) {return self.$getWaponTableProWrestlingCounter()}
      else if ("ST"['$===']($case)) {return self.$getWaponTableStand()}
      else if ("CST"['$===']($case)) {return self.$getWaponTableStandCounter()};
      return $hash2(["name", "table"], {"name": "判定", "table": nil});
    }, $ShinkuuGakuen_getWaponTable$11.$$arity = 1);
    
    Opal.def(self, '$getWaponTableSword', $ShinkuuGakuen_getWaponTableSword$12 = function $$getWaponTableSword() {
      var self = this;

      return $hash2(["name", "table"], {"name": "剣", "table": [[11, "失礼剣", "成功度＋５"], [22, "隼斬り", "回避不可"], [33, "みじん斬り", "攻撃量２倍"], [44, "天地二段", "２連続攻撃"], [55, "波動剣", "カウンター不可、Ｂ・Ｄ"], [66, "疾風剣", "攻撃量３倍､盾受けー１００"], [77, "残像剣", "全体攻撃、Ｂ・Ｄ"], [88, "五月雨斬り」", "回避不可．ダメージ３倍"], [99, "ライジングノヴア」", "２連続攻撃・２撃目敵無防備、Ｂ・Ｄ"], [0, "光速剣", "攻撃量3倍､盾受け不可､カウンター不可、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableSword$12.$$arity = 0);
    
    Opal.def(self, '$getWaponTableSwordCounter', $ShinkuuGakuen_getWaponTableSwordCounter$13 = function $$getWaponTableSwordCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "剣カウンター", "table": [[33, "パリィ", "攻撃の無効化"], [44, nil, nil], [55, nil, nil], [66, "かすみ青眼", "カウンター"], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, "不動剣", "クロスカウンター、Ｂ・Ｄ、ダメージ２倍"]]})
    }, $ShinkuuGakuen_getWaponTableSwordCounter$13.$$arity = 0);
    
    Opal.def(self, '$getWaponTableLongSword', $ShinkuuGakuen_getWaponTableLongSword$14 = function $$getWaponTableLongSword() {
      var self = this;

      return $hash2(["name", "table"], {"name": "大剣", "table": [[11, "スマッシュ", "敵防御半分"], [22, "峰打ち", "麻痺硬化「根性」０"], [33, "水鳥剣", "敵防御判定ー５０"], [44, "ブルクラッシュ", "敵防御力無視"], [55, "逆風の太刀", "カウンター不可、ダメージ２倍"], [66, "濁流剣", "回避不可、カウンター不可、Ｂ・Ｄ"], [77, "清流剣", "回避不可、カウンター不可、Ｂ・Ｄ"], [88, "燕返し", "２連続攻撃・２撃目カウンター不可、Ｂ・Ｄ"], [99, "地ずり残月", "盾受け不可、ダメージ３倍、Ｂ・Ｄ"], [0, "乱れ雪月花", "３連続攻撃・三撃目敵無防備、ダメージ３倍、防御力無視、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableLongSword$14.$$arity = 0);
    
    Opal.def(self, '$getWaponTableLongSwordCounter', $ShinkuuGakuen_getWaponTableLongSwordCounter$15 = function $$getWaponTableLongSwordCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "大剣カウンター", "table": [[22, "無形の位", "攻撃の無効化"], [33, nil, nil], [44, nil, nil], [55, "双破", "クロスカウンター、Ｂ・Ｄ"], [66, nil, nil], [77, nil, nil], [88, "喪心無想", "カウンター、攻撃量６倍"], [99, nil, nil], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableLongSwordCounter$15.$$arity = 0);
    
    Opal.def(self, '$getWaponTableShortSword', $ShinkuuGakuen_getWaponTableShortSword$16 = function $$getWaponTableShortSword() {
      var self = this;

      return $hash2(["name", "table"], {"name": "小剣", "table": [[11, "乱れ突き", "２連続攻撃"], [22, "フェイクタング", "スタン効果「注意力」５"], [33, "マインドステア", "麻痺効果「注意力」０"], [44, "サイドワインダー", "成功度＋３、盾受け不可"], [55, "スクリュードライバー", "防御力無視、ダメージ２倍"], [66, "ニードルロンド", "３連続攻撃"], [77, "プラズマブラスト", "麻痺効果「根性」０、Ｂ・Ｄ"], [88, "サザンクロス", "麻痺効果「根性」５、攻撃量２倍"], [99, "ファイナルレター", "気絶効果「根性」０、回避不可、カウンター不可、Ｂ・Ｄ"], [0, "百花繚乱", "回避不可、盾受け不可、攻撃量３倍、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableShortSword$16.$$arity = 0);
    
    Opal.def(self, '$getWaponTableShortSwordCounter', $ShinkuuGakuen_getWaponTableShortSwordCounter$17 = function $$getWaponTableShortSwordCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "小剣カウンター", "table": [[11, "リポスト", "カウンター"], [22, nil, nil], [33, nil, nil], [44, nil, nil], [55, nil, nil], [66, nil, nil], [77, nil, nil], [88, "マタドール", "カウンター、麻痺効果「注意力」５"], [99, nil, nil], [0, "マリオネット", "攻撃の相手を変える"]]})
    }, $ShinkuuGakuen_getWaponTableShortSwordCounter$17.$$arity = 0);
    
    Opal.def(self, '$getWaponTableSpear', $ShinkuuGakuen_getWaponTableSpear$18 = function $$getWaponTableSpear() {
      var self = this;

      return $hash2(["name", "table"], {"name": "槍", "table": [[11, "チャージ", "ダメージ１．５倍、盾受けー３０"], [22, "稲妻突き", "回避不可"], [33, "脳削り", "麻痺効果「根性」０"], [44, "大車輪", "全体攻撃"], [55, "狂乱撃", "二回攻撃"], [66, "スパイラルチャージ", "盾受け不可、ダメージ２倍、Ｂ・Ｄ"], [77, "双龍波", "スタン効果「注意力」５、盾受け不可、Ｂ・Ｄ"], [88, "流星衝", "カウンター不可、ダメージ３倍、次行動まで攻撃対象にならない"], [99, "ランドスライサー", "全体攻撃、回避不可、カウンター不可、Ｂ・Ｄ"], [0, "無双三段", "三段攻撃、二段目Ｂ・Ｄ、三段目ダメージ２倍、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableSpear$18.$$arity = 0);
    
    Opal.def(self, '$getWaponTableSpearCounter', $ShinkuuGakuen_getWaponTableSpearCounter$19 = function $$getWaponTableSpearCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "槍カウンター", "table": [[55, "風車", "カウンター、ダメージ２倍"], [66, nil, nil], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableSpearCounter$19.$$arity = 0);
    
    Opal.def(self, '$getWaponTableAx', $ShinkuuGakuen_getWaponTableAx$20 = function $$getWaponTableAx() {
      var self = this;

      return $hash2(["name", "table"], {"name": "斧", "table": [[11, "一人時間差", "防御行動ー１００"], [22, "トマホーク", "カウンター不可"], [33, "大木断", "ダメージ２倍"], [44, "ブレードロール", "全体攻撃"], [55, "マキ割りスペシャル", "盾受け不可、Ｂ・Ｄ"], [66, "ヨーヨー", "カウンター不可、２連続攻撃"], [77, "メガホーク", "カウンター不可、全体攻撃、攻撃量２倍"], [88, "デッドリースピン", "回避不可、攻撃量５倍"], [99, "マキ割りダイナミック", "盾受け不可、ダメージ２倍、Ｂ・Ｄ、ターンの最後に命中"], [0, "高速ナブラ", "回避不可、カウンター不可、攻撃量３倍、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableAx$20.$$arity = 0);
    
    Opal.def(self, '$getWaponTableAxCounter', $ShinkuuGakuen_getWaponTableAxCounter$21 = function $$getWaponTableAxCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "斧カウンター", "table": [[44, "真っ向唐竹割り", "クロスカウンター、Ｂ・Ｄ"], [55, nil, nil], [66, nil, nil], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableAxCounter$21.$$arity = 0);
    
    Opal.def(self, '$getWaponTableClub', $ShinkuuGakuen_getWaponTableClub$22 = function $$getWaponTableClub() {
      var self = this;

      return $hash2(["name", "table"], {"name": "棍棒", "table": [[11, "ハードヒット", "防御力無視"], [22, "ダブルヒット", "２連続攻撃"], [33, "回転撃", "防御判定ー１００"], [44, "飛翔脳天撃", "麻痺効果「根性」５"], [55, "削岩撃", "盾受け不可、攻撃量３倍"], [66, "地裂撃", "防御力無視、カウンター不可、盾受け不可、スタン効果「注意力」０"], [77, "トリプルヒット", "３連続攻撃"], [88, "亀甲羅割り", "防御力半分、盾受け不可、Ｂ・Ｄ"], [99, "叩きつぶす", "防御力無視、防御行動、カウンター不可、Ｂ・Ｄ"], [0, "グランドクロス", "防御無視、盾、カウンター不可、ダメージ２倍、Ｂ・Ｄ、全体攻撃"]]})
    }, $ShinkuuGakuen_getWaponTableClub$22.$$arity = 0);
    
    Opal.def(self, '$getWaponTableClubCounter', $ShinkuuGakuen_getWaponTableClubCounter$23 = function $$getWaponTableClubCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "棍棒カウンター", "table": [[11, "ブロッキング", "攻撃の無効化"], [22, nil, nil], [33, nil, nil], [44, nil, nil], [55, nil, nil], [66, "ジャストミート", "飛び道具のみカウンター"], [77, nil, nil], [88, nil, nil], [99, "ホームラン", "すべての攻撃に対するカウンター"], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableClubCounter$23.$$arity = 0);
    
    Opal.def(self, '$getWaponTableBow', $ShinkuuGakuen_getWaponTableBow$24 = function $$getWaponTableBow() {
      var self = this;

      return $hash2(["name", "table"], {"name": "弓", "table": [[11, "影縫い", "麻痺効果「注意力」０"], [22, "アローレイン", "全体攻撃・回避ー５０"], [33, "速射", "２連続攻撃"], [44, "瞬速の矢", "防御不可"], [55, "バラージシュート", "全体攻撃・盾受け不可・攻撃量２倍"], [66, "貫きの矢", "防御力無視、Ｂ・Ｄ"], [77, "落鳳波", "回避不可、Ｂ・Ｄ"], [88, "皆死ね矢", "全体攻撃、気絶効果「根性」５"], [99, "ミリオンダラー", "三連続攻撃"], [0, "夢想弓", "Ｂ・Ｄ、ダメージ３倍"]]})
    }, $ShinkuuGakuen_getWaponTableBow$24.$$arity = 0);
    
    Opal.def(self, '$getWaponTableMartialArt', $ShinkuuGakuen_getWaponTableMartialArt$25 = function $$getWaponTableMartialArt() {
      var self = this;

      return $hash2(["name", "table"], {"name": "体術", "table": [[11, "集気法", "通常ダメージ分自分のＨＰ回復"], [22, "コンビネーション", "２連続攻撃"], [33, "逆一本", "盾受け不可、防御力半分、スタン効果「根性」０"], [44, "コークスクリューブロー", "防御力無視、ダメージ３倍"], [55, "練気拳", "全体攻撃・回避不可"], [66, "バベルクランプル", "盾受け不可、Ｂ・Ｄ"], [77, "マシンガンジャブ", "３連続攻撃"], [88, "ナイアガラフォール", "盾受け不可、Ｂ・Ｄ、ダメージ２倍"], [99, "羅刹掌", "防御力無視、防御不可、Ｂ・Ｄ、ダメージ３倍"], [0, "千手観音", "５連続攻撃、すべてカウンター不可"]]})
    }, $ShinkuuGakuen_getWaponTableMartialArt$25.$$arity = 0);
    
    Opal.def(self, '$getWaponTableMartialArtCounter', $ShinkuuGakuen_getWaponTableMartialArtCounter$26 = function $$getWaponTableMartialArtCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "体術カウンター", "table": [[11, "スウェイバック", "攻撃の無効化"], [22, nil, nil], [33, "当て身投げ", "カウンター"], [44, nil, nil], [55, nil, nil], [66, "ジョルトカウンター", "クロスカウンター、Ｂ・Ｄ"], [77, nil, nil], [88, nil, nil], [99, "ガードキャンセル", $rb_plus("Ｄ１０で振った必殺技によるカウンター", self.$getRandMartialArtCounter())], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableMartialArtCounter$26.$$arity = 0);
    
    Opal.def(self, '$getRandMartialArtCounter', $ShinkuuGakuen_getRandMartialArtCounter$27 = function $$getRandMartialArtCounter() {
      var $a, $b, self = this, value = nil, dice = nil, tableInfo = nil, waponTable = nil, result = nil;

      
      $b = self.$roll(1, 10), $a = Opal.to_ary($b), (value = ($a[0] == null ? nil : $a[0])), $b;
      dice = $rb_plus($rb_times(value, 10), value);
      if ($truthy(value['$=='](110))) {
        dice = 100};
      tableInfo = self.$getWaponTableMartialArt();
      waponTable = tableInfo['$[]']("table");
      result = "" + " ＞ (" + (value) + ")";
      result = $rb_plus(result, self.$getWaponSkillText(waponTable, dice));
      return result;
    }, $ShinkuuGakuen_getRandMartialArtCounter$27.$$arity = 0);
    
    Opal.def(self, '$getWaponTableBoxing', $ShinkuuGakuen_getWaponTableBoxing$28 = function $$getWaponTableBoxing() {
      var self = this;

      return $hash2(["name", "table"], {"name": "ボクシング", "table": [[11, "ワン・ツー", "２連続攻撃・２攻撃目盾受け、回避不可"], [22, "リバーブロー", "麻痺効果「根性」５"], [33, "フリッカー", "２連続攻撃・全て盾受け、カウンター不可"], [44, "コークスクリューブロー", "防御力無視、ダメージ３倍"], [55, "レイ・ガン", "全体攻撃、Ｂ・Ｄ、陽属性魔法攻撃"], [66, "ショットガンブロー", "攻撃量１０倍"], [77, "ハートブレイクショット", "２連続攻撃・１攻撃目防御力無視、ダメージ３倍・２撃目敵無防備"], [88, "デンプシーロール", "３連続攻撃・全てＢ・Ｄ"], [99, "フラッシュピストンマッハパンチ", "全体攻撃、Ｂ・Ｄ、気絶効果「根性」５"], [0, "右", "防御力無視、ダメージ１０倍"]]})
    }, $ShinkuuGakuen_getWaponTableBoxing$28.$$arity = 0);
    
    Opal.def(self, '$getWaponTableBoxingCounter', $ShinkuuGakuen_getWaponTableBoxingCounter$29 = function $$getWaponTableBoxingCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "ボクシングカウンター", "table": [[11, "ダッキングブロー", "カウンター"], [22, "ジョルトカウンター", "クロスカウンター、Ｂ・Ｄ"], [33, nil, nil], [44, nil, nil], [55, nil, nil], [66, nil, nil], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, "ノーガード戦法", "攻撃の無効化、次ターン以降は自分の盾受け、回避不可、全ての攻撃にＢ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableBoxingCounter$29.$$arity = 0);
    
    Opal.def(self, '$getWaponTableProWrestling', $ShinkuuGakuen_getWaponTableProWrestling$30 = function $$getWaponTableProWrestling() {
      var self = this;

      return $hash2(["name", "table"], {"name": "プロレス", "table": [[11, "ボディスラム", "盾受け不可"], [22, "ドロップキック", "Ｂ・Ｄ"], [33, "水車落とし", "盾受け不可、成功度＋５"], [44, "ナックルアロー", "Ｂ・Ｄ、麻痺効果「根性」５"], [55, "ワン・ツー・エルボー", "２連続攻撃"], [66, "バックドロップ", "盾受け不可、ダメージ２倍"], [77, "投げっ放しジャーマン", "盾受け不可、防御力無視、成功度＋５"], [88, "パワーボム", "盾受け不可、ダメージ２倍、Ｂ・Ｄ"], [99, "デスバレーボム", "盾受け不可、防御力無視、ダメージ２倍、気絶効果「根性」５"], [0, "ジャックハマー", "盾受け不可、防御力無視、ダメージ３倍、成功度＋１０"]]})
    }, $ShinkuuGakuen_getWaponTableProWrestling$30.$$arity = 0);
    
    Opal.def(self, '$getWaponTableProWrestlingCounter', $ShinkuuGakuen_getWaponTableProWrestlingCounter$31 = function $$getWaponTableProWrestlingCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "プロレスカウンター", "table": [[22, "パワースラム", "カウンター"], [55, "アックスボンバー", "カウンター、Ｂ・Ｄ"], [66, nil, nil], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableProWrestlingCounter$31.$$arity = 0);
    
    Opal.def(self, '$getWaponTableStand', $ShinkuuGakuen_getWaponTableStand$32 = function $$getWaponTableStand() {
      var self = this;

      return $hash2(["name", "table"], {"name": "幽波紋", "table": [[11, "SILER CHARIOT", "攻撃量５倍、刺しタイプ攻撃"], [22, "TOWER OF GRAY", "防御力無視"], [33, "DARK BLUE MOON", "全体攻撃、攻撃量２倍、水属性斬りタイプ攻撃"], [44, "EMPEROR", "回避不可、盾受け不可、カウンター不可、飛び道具攻撃"], [55, "MAGICIAN's RED", "ダメージ２倍、Ｂ・Ｄ、火属性魔法攻撃"], [66, "DEATH 13", "ダメージ０、全体攻撃、気絶効果「根性」５"], [77, "HIEROPHANT GREEN", "全体攻撃、Ｂ・Ｄ、水属性攻撃"], [88, "VANILLA ICE CREAM", "盾受け不可、カウンター不可、防御力無視、ダメージ３倍、Ｂ・Ｄ"], [99, "THE WORLD", "５連続攻撃、全て敵無防備"], [0, "STAR PLATINUM", "攻撃量１５倍、Ｂ・Ｄ"]]})
    }, $ShinkuuGakuen_getWaponTableStand$32.$$arity = 0);
    
    Opal.def(self, '$getWaponTableStandCounter', $ShinkuuGakuen_getWaponTableStandCounter$33 = function $$getWaponTableStandCounter() {
      var self = this;

      return $hash2(["name", "table"], {"name": "幽波紋カウンター", "table": [[11, "ANUBIS", "技のみカウンター、ダメージ（カウンターした回数の２乗）倍、斬りタイプ攻撃"], [22, nil, nil], [33, nil, nil], [44, nil, nil], [55, nil, nil], [66, "YELLOW TEMPERANE", "魔法・飛び道具含めて全ての攻撃を無効化"], [77, nil, nil], [88, nil, nil], [99, nil, nil], [0, nil, nil]]})
    }, $ShinkuuGakuen_getWaponTableStandCounter$33.$$arity = 0);
    return (Opal.def(self, '$getWaponSkillText', $ShinkuuGakuen_getWaponSkillText$34 = function $$getWaponSkillText(waponTable, dice) {try {

      var $$35, self = this, preName = nil, preEffect = nil;

      
      self.$debug("getWaponSkillText", dice);
      if ($truthy(waponTable['$nil?']())) {
        return ""};
      preName = "";
      preEffect = "";
      $send(waponTable, 'each', [], ($$35 = function(index, name, effect){var self = $$35.$$s || this, $a;

      
        
        if (index == null) {
          index = nil;
        };
        
        if (name == null) {
          name = nil;
        };
        
        if (effect == null) {
          effect = nil;
        };
        name = ($truthy($a = name) ? $a : preName);
        preName = name;
        effect = ($truthy($a = effect) ? $a : preEffect);
        preEffect = effect;
        if ($truthy(index['$=='](dice['$%'](100)))) {
        } else {
          return nil;
        };
        Opal.ret("" + " ＞ 「" + (name) + "」" + (effect));}, $$35.$$s = self, $$35.$$arity = 3, $$35));
      return "";
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $ShinkuuGakuen_getWaponSkillText$34.$$arity = 2), nil) && 'getWaponSkillText';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
